import React from 'react';
import {Popover, Space} from 'antd';
import {CustomerIntegrationModel} from '@/typings/models/Customer';
import {LeadModel} from '@/typings/models/Lead';
import {useHasMarketingDataAccess} from '@/utils/hooks';
import isEmpty from "lodash/isEmpty";

const IntegrationTag = ({integration}: { integration: CustomerIntegrationModel }) => (
  <span>
    {integration.integration_source}
    <span style={{color: '#999', marginLeft: 4}}>{integration.integration_id}</span>
  </span>
);

const LeadCustomerIntegrations = ({lead}: { lead: LeadModel }) => {
  const hasMarketingDataAccess = useHasMarketingDataAccess();
  if (!hasMarketingDataAccess) return null;

  const integrations = lead?.customer?.integrations;
  if (isEmpty(integrations) || !Array.isArray(integrations)) return null;

  const [first, ...rest] = integrations;

  return (
    <Space size={4}>
      <IntegrationTag integration={first}/>
      {rest.length > 0 && (
        <Popover
          content={
            <Space direction="vertical" size={4}>
              {rest.map((integration, index) => (
                <IntegrationTag key={index} integration={integration}/>
              ))}
            </Space>
          }
        >
          <span style={{cursor: 'pointer'}}>(+{rest.length})</span>
        </Popover>
      )}
    </Space>
  );
};

export default LeadCustomerIntegrations;
